var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{attrs:{"fluid":""}},[_c('CSection',[_c('v-tabs',{staticClass:"tabs"},_vm._l((_vm.navigated),function(item){return _c('v-tab',{key:item.route,attrs:{"to":item.route,"link":"","exact-active-class":"link-active"}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }